// extracted by mini-css-extract-plugin
export var o_steps = "steps-module--o_steps--93911";
export var o_steps__btn = "steps-module--o_steps__btn--5aba7";
export var o_steps__buttons = "steps-module--o_steps__buttons--ab114";
export var o_steps__container = "steps-module--o_steps__container--e1cce";
export var o_steps__content = "steps-module--o_steps__content--c994d";
export var o_steps__currentdot = "steps-module--o_steps__currentdot--be1a9";
export var o_steps__desc = "steps-module--o_steps__desc--50ace";
export var o_steps__dot = "steps-module--o_steps__dot--3518f";
export var o_steps__dots = "steps-module--o_steps__dots--52eac";
export var o_steps__label = "steps-module--o_steps__label--7760c";
export var o_steps__mobile = "steps-module--o_steps__mobile--effc6";
export var o_steps__number = "steps-module--o_steps__number--4156c";
export var o_steps__pastdot = "steps-module--o_steps__pastdot--cecbd";
export var o_steps__selectedlabel = "steps-module--o_steps__selectedlabel--61a74";
export var o_steps__selectednum = "steps-module--o_steps__selectednum--b2a15";
export var o_steps__tab = "steps-module--o_steps__tab--a5a28";
export var o_steps__tabs = "steps-module--o_steps__tabs--dec1b";